import { useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ProtectedLeadRoute({ children }) {
  const [authState, setAuthState] = useState(null);

  useEffect(() => {
    let active = true;

    const checkAuth = async () => {
      try {
        await axios.get(`${API}/auth/me`, { withCredentials: true });
        if (active) {
          setAuthState(true);
        }
      } catch {
        if (active) {
          setAuthState(false);
        }
      }
    };

    checkAuth();
    return () => {
      active = false;
    };
  }, []);

  if (authState === null) {
    return (
      <section className="px-6 pb-16 pt-14 sm:px-8 lg:px-12" data-testid="lead-route-checking-state">
        <div className="mx-auto max-w-4xl glitter-card glass-panel rounded-[2rem] p-6 text-white/[0.72]">
          Checking private access…
        </div>
      </section>
    );
  }

  if (authState === false) {
    return <Navigate to="/lead-tracker-login" replace />;
  }

  return children;
}